/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import classNames from 'classnames';
import { v4 as uuid } from 'uuid';
import Spinner from 'react-spinkit';
import PlacesAutocomplete from 'react-places-autocomplete';
import DatePicker from '../../../common/components/Form/DatePicker';
import './RenderField.css';

export default class RenderField extends Component {
  constructor(props) {
    super(props);
    // this state below also seems unused
    this.state = { address: '' };

    this.onAddressChange = this.onAddressChange.bind(this);
  }

  onAddressChange(address) {
    const { input } = this.props;
    const { onChange } = input;
    this.setState({ address });
    onChange(address);
  }

  render() {
    const {
      containerName,
      input,
      inputmode,
      fieldId,
      label,
      labelledBy,
      /*
        note, this is not defined - when `RenderField` is used by `Field`, the
        `name` is passed as a member of the `input` prop
      */
      name,
      type,
      placeholder,
      helpText,
      helpTextId,
      className,
      options,
      prepend,
      append,
      onSelect,
      readOnly,
      disabled,
      disableCopy,
      addressErrorDetail,
      defaultSelectValue,
      meta:
        {
          touched,
          error,
          warning,
        },
    } = this.props;

    const controlId = (fieldId != null && fieldId !== '') ? fieldId : input.name;

    switch (type) {
      case 'checkbox': {
        const checkboxHelpId = helpText ? (helpTextId || `${controlId}-help`) : null;
        const checkboxErrorId = (touched && error) ? `${controlId}-error` : null;
        const checkboxDescribedBy = [checkboxHelpId, checkboxErrorId].filter(Boolean).join(' ') || undefined;
        return (
          <div
            className={classNames(className)}
            data-field-name={input.name}
          >
            <div className="checkbox checkbox-div">
              <input
                {...input}
                placeholder={label}
                type={type}
                className="form-check-input"
                autoComplete="none"
                id={controlId}
                aria-describedby={checkboxDescribedBy}
                aria-invalid={!!(touched && error)}
              />
              {/* will we be implementing any kind of form controls here? */}
              <label
                htmlFor={controlId}
                className={classNames(
                  'form-check-label',
                  { error: touched && error && error !== null },
                )
                }
              >{label}
              </label>
              <span
                className={classNames('checkmark', { checked: input.value })}
                // shouldn't we be using
                // ref={(c) => { this.checkmark = c }} instead of ref string literals?
                ref="checkmark"
              />
            </div>
            {helpText && <small id={checkboxHelpId} className="form-text text-muted">{helpText}</small>}
            {touched && error && (
              <div id={checkboxErrorId} className="is-error invalid-feedback">{error}</div>
            )}
          </div>
        );
      }
      case 'radio':
      case 'password':
      case 'tel':
      case 'text': {
        const helpId = helpText ? (helpTextId || `${controlId}-help`) : null;
        const errorId = (touched && error) ? `${controlId}-error` : null;
        const ariaDescribedBy = [helpId, errorId].filter(Boolean).join(' ') || undefined;
        const onCopy = disableCopy ? (e) => e.preventDefault() : undefined;
        return (
          <div
            className={classNames(
              'form-group',
              className,
            )}
            data-field-name={input.name}

          >
            {label && <label htmlFor={controlId}>{label}</label>}
            <div className={classNames(
              'input',
              { error: touched && error },
              'input-group',
            )}
            >
              {prepend &&
              <div className="input-group-prepend">
                <span className={`input-group-text ${disabled ? 'disabled' : ''}`}>
                  <span className={`icon nyl-sso-icon-${prepend}`} aria-hidden="true" />
                </span>
              </div>
              }
              {readOnly ?
                <input
                  className="form-control-plaintext"
                  {...input}
                  placeholder={placeholder}
                  type={type}
                  autoComplete="none"
                  readOnly
                  inputMode={inputmode || 'text'}
                  id={controlId}
                  aria-describedby={ariaDescribedBy}
                  aria-invalid={!!(touched && error)}
                  onCopy={onCopy}
                />
                :
                <input
                  className="form-control"
                  {...input}
                  placeholder={placeholder}
                  type={type}
                  autoComplete="none"
                  disabled={disabled}
                  inputMode={inputmode || 'text'}
                  id={controlId}
                  aria-describedby={ariaDescribedBy}
                  aria-invalid={!!(touched && error)}
                  onCopy={onCopy}
                />

              }
              {append &&
              <div className="input-group-append">
                <span className="input-group-text">
                  <span className={`icon nyl-sso-icon-${append}`} aria-hidden="true" />
                </span>
              </div>
              }
            </div>
            {helpText && <small id={helpId} className="form-text text-muted">{helpText}</small>}
            {touched && error && <div id={errorId} className="is-error invalid-feedback">{error}</div>}
          </div>
        );
      }

      case 'places-autocomplete':
        /*
          Note, `data-field-name` is not implemented for this field type,
          however, it is never used in the codebase, so this is okay for now.
        */
        return (
          <PlacesAutocomplete
            value={this.state.address}
            onChange={this.onAddressChange}
            placeholder={placeholder}
            onSelect={onSelect}
            type={type}
            searchOptions={{ types: ['address'] }}
          >
            {({
              getInputProps, suggestions, getSuggestionItemProps, loading,
            }) => (
              <div className={classNames(
                'form-group',
                className,
              )}
              >
                {label && <label htmlFor={controlId}>{label}</label>}
                <div className={classNames(
                  'input',
                  { error: touched && error !== null },
                  'input-group',
                )}
                >
                  <input
                    aria-describedby="addressAutocomplete"
                    autoComplete="none"
                    {...getInputProps({
                      placeholder,
                      className: 'form-control',
                      id: controlId,
                    })}
                  />
                </div>
                <div className="autocomplete-results center">
                  {loading && <Spinner className="spinner" name="ball-spin-fade-loader" />}
                  {suggestions.map((suggestion) => {
                    const className = suggestion.active
                      ? 'active'
                      : '';
                    // inline style for demonstration purpose
                    const style = {
                      backgroundColor: (suggestion.active ? '#fafafa' : '#ffffff'),
                      cursor: 'pointer',
                    };
                    return (
                      <div
                        {...getSuggestionItemProps(suggestion, {
                          className,
                          style,
                        })}
                      >
                        <a href="#" className="list-group-item list-group-item-action">{suggestion.description}</a>
                      </div>
                    );
                  })}
                </div>
                {helpText && <small id={helpTextId} className="form-text text-muted">{helpText}</small>}
                {addressErrorDetail && <div className="is-error invalid-feedback">{addressErrorDetail}</div>}
              </div>
            )}
          </PlacesAutocomplete>
        );

      case 'places-autocomplete-vtwo': {
        const pacHelpId = helpText ? (helpTextId || `${controlId}-help`) : null;
        const pacErrorId = (touched && error) ? `${controlId}-error` : null;
        const pacDescribedBy = [pacHelpId, pacErrorId].filter(Boolean).join(' ') || undefined;
        return (
          <div
            className={classNames(
              'form-group',
              className,
            )}
            data-field-name={input.name}
          >
            {label && <label htmlFor={controlId}>{label}</label>}
            <div className={classNames(
              'input',
              { error: touched && error !== null },
              'input-group',
            )}
            >
              {prepend &&
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <span className={`icon nyl-sso-icon-${prepend}`} aria-hidden="true" />
                </span>
              </div>
              }
              <input
                className="form-control"
                {...input}
                placeholder={placeholder}
                type={type}
                autoComplete="none"
                id={controlId}
                aria-describedby={pacDescribedBy}
                aria-invalid={!!(touched && error)}
              />
              {append &&
              <div className="input-group-append">
                <span className="input-group-text">
                  <span className={`icon nyl-sso-icon-${append}`} aria-hidden="true" />
                </span>
              </div>
              }
            </div>
            {helpText && <small id={pacHelpId} className="form-text text-muted">{helpText}</small>}
            {touched && error && <div id={pacErrorId} className="is-error invalid-feedback">{error}</div>}
          </div>
        );
      }
      case 'select': {
        const selectHelpId = helpText ? (helpTextId || `${controlId}-help`) : null;
        const selectErrorId = (touched && error) ? `${controlId}-error` : null;
        const selectAriaDescribedBy = [selectHelpId, selectErrorId].filter(Boolean).join(' ') || undefined;
        const { value: selectValueRaw, ...selectInputRest } = input;
        const selectValue = (selectValueRaw === 0 || selectValueRaw === '0' || selectValueRaw === undefined || selectValueRaw === null)
          ? ''
          : selectValueRaw;
        return (
          <div
            className={classNames(
              'form-group',
              { error: touched && error },
              className,
            )}
            data-field-name={input.name}
          >
            {label ? <label htmlFor={controlId}>{label}</label> : null}
            <div>
              <select
                className="custom-select"
                {...selectInputRest}
                value={selectValue}
                id={controlId}
                aria-labelledby={label ? undefined : (labelledBy || undefined)}
                aria-describedby={selectAriaDescribedBy}
                aria-invalid={!!(touched && error)}
              >
                <option value="" disabled>{defaultSelectValue}</option>
                {options && options.length > 0 &&
                  options.map((option) =>
                    <option key={uuid()} value={option}>{option}</option>)
                }
              </select>
              {helpText && <small id={selectHelpId} className="form-text text-muted">{helpText}</small>}
              {touched && error && <div id={selectErrorId} className="is-error invalid-feedback">{error}</div>}
            </div>
          </div>
        );
      }
      case 'datepicker': {
        const dpHelpId = helpText ? (helpTextId || `${controlId}-help`) : null;
        const dpErrorId = (touched && error) ? `${controlId}-error` : null;
        const dpDescribedBy = [dpHelpId, dpErrorId].filter(Boolean).join(' ') || undefined;
        return (
          <div
            className={classNames(
              'form-group',
              className,
            )}
            data-field-name={input.name}
          >
            <label htmlFor={controlId}>{label}</label>
            <div className={classNames(
              'input',
              { error: touched && error !== null },
              'input-group',
            )}
            >
              {prepend &&
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <span className={`icon nyl-sso-icon-${prepend}`} aria-hidden="true" />
                  </span>
                </div>
              }
              <DatePicker
                {...input}
                id={controlId}
                ariaDescribedBy={dpDescribedBy}
                ariaInvalid={!!(touched && error)}
              />
            </div>
            {helpText && <small id={dpHelpId} className="form-text text-muted">{helpText}</small>}
            {touched && error && <div id={dpErrorId} className="error_str invalid-feedback">{error}</div>}
          </div>
        );
      }
      default: {
        const defaultErrorId = (touched && error) ? `${controlId}-error` : null;
        return (
          <div
            className={classNames(
              'form-group',
              className,
            )}
            data-field-name={input.name}
          >
            <label htmlFor={controlId}>{label}</label>
            <div className={classNames('input', { error: touched && error !== null })}>
              <input
                className="form-control"
                {...input}
                placeholder={placeholder}
                type={type}
                autoComplete="none"
                id={controlId}
                aria-describedby={defaultErrorId || undefined}
                aria-invalid={!!(touched && error)}
              />
              {touched && error && <div id={defaultErrorId} className="error_str">{error}</div>}
            </div>
          </div>
        );
      }
    }
  }
}
